import {
  BANNER_INFO,
  ACTIVITY_SUMMARIES,
  LATEST_NEWS,
  BANNER_INFO_MOBILE,
} from '@/utils/const/activity';

import styles from '@/styles/common.module.scss';
import ActivitySummary from '@/components/activityComponents/activitySummary';
import LatestNews from '@/components/activityComponents/latestNews';
import DetailBanner from '@/components/commonComponents/detailBanner';
import { useUserAgentInfo } from '@/context/user-agent';
import { useWebPResourceCompatibleFn } from '@/hooks/useWebPResource';
import { src } from '@/utils/common';

const Banner = ({ title, description, image }: typeof BANNER_INFO) => {
  const { isMobile } = useUserAgentInfo();
  const webPResourceHandleFn = useWebPResourceCompatibleFn();
  if (isMobile) {
    return (
      <div
        className={styles['simple-mobile-banner']}
        style={{
          backgroundImage: `url(${webPResourceHandleFn(src(image))})`,
        }}
      >
        <div className={styles['title']}>{title}</div>
        <div className={styles['desc']}>{description}</div>
      </div>
    );
  } else {
    return (
      <DetailBanner
        bannerData={{
          title,
          description,
          backgroundImg: image,
        }}
      />
    );
  }
};

const News = () => {
  const { isMobile } = useUserAgentInfo();
  const bannerInfo = isMobile ? BANNER_INFO_MOBILE : BANNER_INFO;
  return (
    <div className={styles['wrapper']}>
      <Banner {...bannerInfo} />
      <ActivitySummary {...ACTIVITY_SUMMARIES} />
      <LatestNews {...LATEST_NEWS} />
    </div>
  );
};

export default News;
